// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";
import { alertsClasses as myClasses } from "../../";

import { Route, Switch } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { alertComposeActions, alertListActions } from "../../../../actions";

import { GeoFence, IGeoFenceProps } from "./geo-fence";
import { Groups, IGroupsProps } from "./groups";
import { IMainProps, Main } from "./main";

import "./styles.css";

interface IChooseAudienceProps
  extends IGeoFenceProps,
    IGroupsProps,
    IMainProps {
  routeProps?: any;
  onCopyData: (id: string) => (dispatch: Dispatch<any>) => Promise<void>;
  onBoxClicked: (
    id: string,
    history: any
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onManageGroupList: (
    type: string
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onAudienceListCheckBoxChanged: (
    id: string
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onSaveLayerClick: (
    currentItem: any
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onClearMap: (id: string) => (dispatch: Dispatch<any>) => Promise<void>;
  onShapeComplete: (shape: any) => (dispatch: Dispatch<any>) => Promise<void>;
  onSaveAudienceGroups: (
    group: any,
    history: any
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onCancelAudienceGroups: (
    history: any
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onUpdateGeoFence: (
    status: boolean,
    history: any
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onNextClick(event: any): void;
}

class ChooseAudience extends React.Component<IChooseAudienceProps> {
  constructor(props: IChooseAudienceProps) {
    super(props);
    this.onBoxClick = this.onBoxClick.bind(this);
    this.onCancelClick = this.onCancelClick.bind(this);
    this.onSaveClick = this.onSaveClick.bind(this);

    this.onSaveGroupsClick = this.onSaveGroupsClick.bind(this);
    this.onCancelGroupsClick = this.onCancelGroupsClick.bind(this);

    this.onGroupsSelectChange = this.onGroupsSelectChange.bind(this);
    this.onGroupsSortChange = this.onGroupsSortChange.bind(this);
    this.onSaveLayerClick = this.onSaveLayerClick.bind(this);
    this.onClearMap = this.onClearMap.bind(this);
    this.onAudienceListCheckBoxChanged = this.onAudienceListCheckBoxChanged.bind(
      this
    );
    this.onShapeComplete = this.onShapeComplete.bind(this);
  }

  public componentDidMount() {
    this.props.onCopyData("chooseAudience");
  }

  public render() {
    const {
      everyoneStatus,
      groupsStatus,
      className,
      list,
      geoFence,
      groupTagList,
      groupsSelected
    } = this.props;

    const classes = classNames(
      myClasses.ALERTS_CONTENT_COMPOSE_CHOOSE_AUDIENCE,
      className
    );

    return (
        <Switch>
          <Route
            exact={true}
            path="/alerts/compose/choose-audience/"
            render={routeProps => (
              <Main
                className={classes}
                {...routeProps}
                groupTagList={groupTagList}
                everyoneStatus={everyoneStatus}
                groupsStatus={groupsStatus}
                geoFence={geoFence}
                onClearMap={this.onClearMap}
                onBoxClick={this.onBoxClick}
              />
            )}
          />
          <Route
            exact={true}
            path="/alerts/compose/choose-audience/group"
            render={routeProps => (
              <Groups
                {...routeProps}
                list={list}
                groupsSelected={groupsSelected}
                onAudienceBoxCheckBoxChange={this.onAudienceListCheckBoxChanged}
                onSaveGroupsClick={this.onSaveGroupsClick}
                onCancelClick={this.onCancelGroupsClick}
                onGroupsSelectChange={this.onGroupsSelectChange}
                onGroupsSortChange={this.onGroupsSortChange}
              />
            )}
          />
          <Route
            exact={true}
            path="/alerts/compose/choose-audience/geofence"
            render={() => (
              <GeoFence
                onSaveClick={this.onSaveClick}
                onCancelClick={this.onCancelClick}
                onSaveLayerClick={this.onSaveLayerClick}
                geoFence={geoFence}
                onShapeComplete={this.onShapeComplete}
              />
            )}
          />
        </Switch>
    );
  }

  private onClearMap(event: any) {
    this.props.onClearMap("chooseAudience");
  }

  private onSaveLayerClick(event: any, listItem: any) {
    this.props.onSaveLayerClick(listItem);
  }

  private onShapeComplete(event: any, shape: any) {
    this.props.onShapeComplete(shape);
  }

  private onAudienceListCheckBoxChanged(event: any, index: number) {
    const id = index.toString();
    this.props.onAudienceListCheckBoxChanged(id);
  }

  private onGroupsSelectChange(event: any) {
    this.props.onManageGroupList(event.currentTarget.textContent);
  }

  private onGroupsSortChange(event: any) {
    this.props.onManageGroupList(event.currentTarget.textContent);
  }

  private onBoxClick(event: any) {
    const { routeProps } = this.props;
    const { history } = routeProps;
    const id = event.currentTarget.dataset.id;
    this.props.onBoxClicked(id, history);
  }

  private onCancelClick(event: any) {
    const id = event.currentTarget.dataset.id;
    const history = this.props.routeProps.history;
    const status = false;
    const { onUpdateGeoFence } = this.props;
    if (id === "geo-fence") {
      onUpdateGeoFence(status, history);
    } 
  }

  private onSaveClick(event: any) {
    const id = event.currentTarget.dataset.id;
    const history = this.props.routeProps.history;
    const status = true;
    const { onUpdateGeoFence } = this.props;
    if (id === "geo-fence") {
      onUpdateGeoFence(status, history);
    }
  }

  private onCancelGroupsClick(event: any) {
    const history = this.props.routeProps.history;
    this.props.onCancelAudienceGroups(history);
  }

  private onSaveGroupsClick(event: any, list: any) {
    const history = this.props.routeProps.history;
    this.props.onSaveAudienceGroups(list, history);
  }

}

const mapStateToProps = (state: any) => {
  const { alerts } = state;
  const { composeData } = alerts;
  const { chooseAudience } = composeData;

  const { audiences, geoFence } = chooseAudience;
  const { groups, everyone } = audiences;
  const { list, groupTagList, selected } = groups;

  return {
    audiences,
    geoFence,
    groupsStatus: groups.status,
    everyoneStatus: everyone.status,
    history,
    list,
    groupTagList,
    groupsSelected: selected
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    onToggleRightPanel: bindActionCreators(
      alertListActions.onToggleRightPanel,
      dispatch
    ),
    onBoxClicked: bindActionCreators(
      alertComposeActions.onChooseAudienceBoxClicked,
      dispatch
    ),
    onUpdateStepperStep: bindActionCreators(
      alertComposeActions.onUpdateStepper,
      dispatch
    ),
    onManageGroupList: bindActionCreators(
      alertComposeActions.onManageGroupList,
      dispatch
    ),
    onAudienceListCheckBoxChanged: bindActionCreators(
      alertComposeActions.onAudienceListCheckBoxChanged,
      dispatch
    ),
    onCancelAudienceGroups: bindActionCreators(
      alertComposeActions.onCancelAudienceGroups,
      dispatch
    ),
    onSaveAudienceGroups: bindActionCreators(
      alertComposeActions.onSaveAudienceGroups,
      dispatch
    ),
    onUpdateGeoFence: bindActionCreators(
      alertComposeActions.onUpdateGeoFence,
      dispatch
    ),
    onClearMap: bindActionCreators(alertComposeActions.onClearMap, dispatch),
    onSaveLayerClick: bindActionCreators(
      alertComposeActions.onChooseAudienceUpdateGeoMapList,
      dispatch
    ),
    onShapeComplete: bindActionCreators(
      alertComposeActions.onChooseAudienceUpdateGeoMapShape,
      dispatch
    ),
    onCopyData: bindActionCreators(alertComposeActions.onCopyData, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChooseAudience);



// WEBPACK FOOTER //
// ./src/controllers/alerts/compose/choose-audience/choose-audience.tsx